// extracted by mini-css-extract-plugin
export var fullWidthButton = "_rj-0";